import api from './api'

export const humanSessionAPI = {
  start: async ({ caseId, behaviorConfig = null, providers = ['openai'] }) => {
    const response = await api.post('/osa/human-session/start', {
      case_id: caseId,
      behavior_config: behaviorConfig,
      providers,
    })
    return response.data
  },

  patientReply: async (sessionId, { humanUtterance, turnType = 'open' }) => {
    const response = await api.post(`/osa/human-session/${sessionId}/patient-reply`, {
      human_utterance: humanUtterance,
      turn_type: turnType,
    }, { timeout: 120000 })
    return response.data
  },

  // Submit runs the trainee scoring PLUS the agent's full 5-call phase interview,
  // its scoring, and the coaching pass — well over the 30s default.
  submitAssessment: async (sessionId, { humanAssessment, providers = ['openai'] }) => {
    const response = await api.post(`/osa/human-session/${sessionId}/submit-assessment`, {
      human_assessment: humanAssessment,
      providers,
    }, { timeout: 600000 })
    return response.data
  },

  getSummary: async (sessionId, providers = ['openai']) => {
    const response = await api.get(
      `/osa/human-session/${sessionId}/summary?providers=${providers.join(',')}`,
      { timeout: 300000 }
    )
    return response.data
  },

  transcribeAudio: async (audioBlob) => {
    const formData = new FormData()
    formData.append('audio', audioBlob, 'recording.webm')
    const response = await api.post('/osa/transcribe', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },
}
